import React from 'react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { SectionHeading } from '../components/SectionHeading';
import { BookingForm } from '../components/BookingForm';
import { ContactPanel } from '../components/ContactPanel';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
export function Contact() {
  const {
    t
  } = useLanguage();
  const page = copy.pages.contact;
  return <>
      <Seo title={t(copy.seo.contact.title)} description={t(copy.seo.contact.description)} data-id="element-365" data-mp="t1m7r0fue8b4" />
      <PageHeader eyebrow={t(page.eyebrow)} title={t(page.title)} description={t(page.description)} data-id="element-366" data-mp="17r0myp63njyf" />

      <section className="bg-navy-50 py-14 sm:py-16" data-id="element-367" data-mp="12z0hyib6a0uz">
        <div className="mx-auto max-w-3xl px-6" data-id="element-368" data-mp="f9y1hds9ye22">
          <BookingForm data-id="element-369" data-mp="f8mxpdytx6ay" />
        </div>
      </section>

      <section className="bg-white py-16 sm:py-20" data-id="element-370" data-mp="abmq2ymbzvhq">
        <div className="mx-auto max-w-7xl px-6" data-id="element-371" data-mp="aauuvownbzrz">
          <SectionHeading title={t(page.visitTitle)} description={t(page.visitDescription)} data-id="element-372" data-mp="15fyonl3kzbod" />
          <div className="mt-10" data-id="element-373" data-mp="19fpjbzw8aby6">
            <ContactPanel data-id="element-374" data-mp="19enwky5uo10m" />
          </div>
        </div>
      </section>
    </>;
}